import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "absolute top-2 w-full xl:min-w-100 bg-tile p-4 rounded-lg border border-tile-border w-110 space-y-4" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["href", "textContent"]

import {computed, nextTick, onMounted, ref} from "vue";
import {SearchItem, SearchItemType} from "../../../../../Application/Navigation/Port/SearchPrompt";
import {useClickOutside} from "../../../Helper/clickOutside";
import Icon from "../../../Icon/Icon.vue";
import {useNavigationStore} from "../navigationStore";
import {useNavigationService} from "../vue";

interface GroupedByType {
  [type: SearchItemType]: SearchItem[];
}

export default /*@__PURE__*/_defineComponent({
  __name: 'SearchField',
  setup(__props) {

const service = useNavigationService();
const store = useNavigationStore();

const searchPhrase = ref<string>('');
const searchInput = ref<HTMLInputElement>();

function searchStart(): void {
  suspendEntryPoints(true);
  nextTick(() => {
    searchInput.value!.focus();
  });
}

function search(): void {
  service.search(searchPhrase.value);
  searchCloseForced.value = false;
}

function suspendEntryPoints(suspended: boolean): void {
  store.navigationEntryPointsSuspended = suspended;
}

function cancelSearch(): void {
  suspendEntryPoints(false);
  store.searchItems = [];
  searchPhrase.value = '';
  searchInput.value!.blur();
}

const searchCloseForced = ref<boolean>(false);
const clickOutside = useClickOutside(false);
const searchHasItems = computed<boolean>(() => {
  return store.searchItems.length > 0;
});

onMounted(() => {
  clickOutside.addClickListener(() => {
    cancelSearch();
  });
});

const searchItemsVisible = computed<boolean>(() => {
  return searchHasItems.value && !searchCloseForced.value;
});

function searchItemTypeTitle(type: SearchItemType): string {
  const titles: Record<SearchItemType, string> = {
    jobOffer: 'Oferty pracy',
    user: 'Użytkownicy',
    topic: 'Wątki',
    article: 'Artykuły',
  };
  return titles[type];
}

const searchItemsGroupedByType = computed<GroupedByType>(() => {
  return Object.groupBy(store.searchItems, searchItem => searchItem.type);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(['flex-grow-1', {'max-xl:hidden': !_unref(store).navigationEntryPointsSuspended}, _ctx.$attrs.class])
    }, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "searchInput",
        ref: searchInput,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((searchPhrase).value = $event)),
          search
        ],
        class: "w-full border border-tile-border rounded-lg p-2 outline-none",
        placeholder: "Wyszukaj",
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (suspendEntryPoints(true))),
        onKeyup: _withKeys(cancelSearch, ["esc"]),
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, null, 544 /* NEED_HYDRATION, NEED_PATCH */), [
        [_vModelText, searchPhrase.value]
      ]),
      (searchItemsVisible.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "relative",
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchItemsGroupedByType.value, (searchItems, type) => {
                return (_openBlock(), _createElementBlock("div", null, [
                  _createElementVNode("div", {
                    class: "text-neutral2-500 text-sm",
                    textContent: _toDisplayString(searchItemTypeTitle(type))
                  }, null, 8 /* PROPS */, _hoisted_2),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchItems, (searchItem) => {
                    return (_openBlock(), _createElementBlock("a", {
                      class: "block hover:accent whitespace-nowrap truncate py-1 px-2 rounded -mx-2",
                      href: searchItem.contentHref,
                      "data-testid": "searchItem",
                      textContent: _toDisplayString(searchItem.title)
                    }, null, 8 /* PROPS */, _hoisted_3))
                  }), 256 /* UNKEYED_FRAGMENT */))
                ]))
              }), 256 /* UNKEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    (!_unref(store).navigationEntryPointsSuspended)
      ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          name: "navigationSearch",
          class: _normalizeClass(["px-1 mr-1 cursor-pointer xl:hidden", [_ctx.$attrs.class]]),
          onClick: _withModifiers(searchStart, ["stop"])
        }, null, 8 /* PROPS */, ["class"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})